import styles from './progressBar.module.css';
import React from 'react';
import {Typography} from '@toppy-webshop/toppy-design-system';
import icon from '../../assets/images/icons/location_onthemove.png';

interface ProgressBarProps {
    states: Record<string, {description: string}>;
    currentState: string;
}

const ProgressBar = ({states, currentState}: ProgressBarProps) => {
    const progress =
        Object.keys(states).indexOf(currentState) === 0
            ? 5
            : (Object.keys(states).indexOf(currentState) /
                  Object.keys(states).length) *
              100;
    return (
        <section className={styles.container}>
            <Typography size={'s'} weight={'bold'}>
                {states[currentState].description}
            </Typography>
            <div className={styles.total}>
                <div className={styles.dots}>
                    {Object.keys(states).map(() => {
                        return <div className={styles.dot} />;
                    })}
                </div>
                <div>
                    <div
                        className={styles.current}
                        style={{
                            width: progress.toFixed(2) + '%',
                        }}
                    >
                        <div className={styles['regular-icon']}>
                            <img
                                alt="Voortgang"
                                className={styles.icon}
                                src={icon}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProgressBar;
